/**
 * Helpers to map API responses into UI-friendly structures for the dashboard.
 */

export function mapInventoryMetrics(items) {
  const arr = Array.isArray(items) ? items : [];
  const totalItems = arr.length;

  const lowStockCount = arr.filter((i) => Boolean(i?.is_low_stock)).length;
  const needsReorderCount = arr.filter((i) => Boolean(i?.needs_reorder)).length;

  const lowestAvailable = arr
    .slice()
    .sort((a, b) => (a?.available_quantity || 0) - (b?.available_quantity || 0))
    .slice(0, 5);

  const timestamps = arr
    .map((i) => {
      const t = i?.last_updated ? Date.parse(i.last_updated) : 0;
      return Number.isFinite(t) ? t : 0;
    })
    .filter((t) => t > 0);

  const lastUpdatedLatest = timestamps.length ? new Date(Math.max(...timestamps)) : null;

  return {
    totalItems,
    lowStockCount,
    needsReorderCount,
    lowestAvailable,
    lastUpdatedLatest,
  };
}

export function mapTopFlavours(items) {
  const arr = Array.isArray(items) ? items : [];
  const sorted = arr.slice().sort((a, b) => (b?.total_wholesale_revenue || 0) - (a?.total_wholesale_revenue || 0));
  return sorted.slice(0, 5).map((x) => ({
    flavor: x?.flavor ?? x?.name ?? 'Unknown',
    totalWholesaleRevenue: x?.total_wholesale_revenue || 0,
    totalWholesaleVolume: x?.total_wholesale_volume || 0,
    wholesaleMargin: x?.wholesale_margin ?? null,
    retailMargin: x?.retail_margin ?? null,
  }));
}